import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white px-2" }
const _hoisted_2 = { class: "flex flex-col gap-[5px] pt-3 mt-3" }
const _hoisted_3 = { class: "flex justify-center mt-2 text-sm'" }
const _hoisted_4 = { class: "flex w-full pt-16" }
const _hoisted_5 = { class: "text-sm text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_db_input = _resolveComponent("db-input")!
  const _component_db_button = _resolveComponent("db-button")!
  const _component_db_form = _resolveComponent("db-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_db_form, { class: "flex flex-col gap-[5px]" }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("landing.reset_password.code_info")), 1),
          _createVNode(_component_db_input, {
            variant: "outline",
            placeholder: _ctx.$t('landing.reset_password.code') + '*',
            label: _ctx.$t('landing.reset_password.code') + '*',
            name: "code",
            ariainvalid: _ctx.errors.code ? 'true' : '',
            modelValue: _ctx.user.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.code) = $event))
          }, null, 8, ["placeholder", "label", "ariainvalid", "modelValue"]),
          _createElementVNode("p", {
            class: _normalizeClass(
            _ctx.errors.code == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          )
          }, _toDisplayString(_ctx.$t("landing.reset_password.error_reset_password")), 3),
          _createVNode(_component_db_button, {
            id: "login",
            variant: "brand-primary",
            "class-list": "w-full mt-2",
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing.reset_password.confirm")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_db_button, {
            id: "login",
            variant: "tertiary-plain",
            "class-list": "w-full mt-2",
            onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/reset-password-guest'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing.reset_password.not_recieved")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("landing.required_field")), 1)
      ])
    ])
  ]))
}